import { galleryApi } from '../../api/gallery';
import { createCategorySlice } from './categorySlice';
import { createContentSlice } from './contentSlice';

const { slice, actions } = createContentSlice({
  name: 'gallery',
  api: galleryApi,
  hasPublish: true,
});

const categoryFactory = createCategorySlice({
  name: 'galleryCategories',
  api: galleryApi.categories,
});

export const galleryReducer = slice.reducer;
export const galleryActions = actions;

export const galleryCategoryReducer = categoryFactory.slice.reducer;
export const galleryCategoryActions = categoryFactory.actions;

export const selectGalleryItems = (state) => state.gallery.items;
export const selectGalleryStatus = (state) => state.gallery.status;
export const selectGalleryCategories = (state) => state.galleryCategories.items;
